// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import logo from '../../images/common/quickmd-main-logo.png'
import './servererror.scss'

export const ServerError = () => (
  <div className='server-error-container'>
    <img src={logo} alt='Logo' className='server-error-logo' />
    <span className='server-error-label'>500 internal server error.</span>
  </div>
)
